module.exports = __webpack_public_path__ + "img/request.2fb41f39.svg";